import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import Grid2 from "@mui/material/Grid2";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

export const DrawingVersionColumn = ({ data }: Props) => {
	const {
		state: { dataDrawingSelected },
	} = useWorkOrderModalsContext();
	if (data.id === -1) {
		return (
			<Grid2
				container
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid2 style={{ alignItems: "center", justifyContent: "center" }}>
					{dataDrawingSelected?.Version}
				</Grid2>
			</Grid2>
		);
	} else if (data.id !== -1) {
		return <>{data?.Version}</>;
	} else return <></>;
};
